import { AppSettings } from '../app.settings';
import { GeneralLogScreenFiltersDataModel } from './general-log-screen-filters-data-model';

export class GeneralLogScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: GeneralLogScreenFiltersDataModel = new GeneralLogScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: GeneralLogScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
